var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2457 0.846161H1.75336C1.1072 0.846161 0.737973 1.63078 1.15336 2.13847L10.1534 12.6154C10.4303 12.9385 10.6149 13.4 10.6149 13.8154V20.4615C10.6149 20.8308 10.938 21.1539 11.3072 21.1539H12.6918C13.061 21.1539 13.3841 20.8308 13.3841 20.4615V13.8154C13.3841 13.3539 13.5226 12.9385 13.8457 12.6154L22.8457 2.13847C23.261 1.63078 22.938 0.846161 22.2457 0.846161Z",
    fill: "#13B76E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterProjects);
export default __webpack_public_path__ + "static/media/filter-projects.9a1806436eefada6fecefdaba5c0aca9.svg";
export { ForwardRef as ReactComponent };